import Store from "./store";

export const cookieStore = new Store("cookie");

export const localStore = new Store("local");

export const sessionStore = new Store("session");
